<template>
	<div class="u-container">
		<div class="form-container u-container">
			<form @submit.prevent="submitInquiryForm">
				<h2 class="form-title">문의사항 입력</h2>

				<div class="form-group">
					<label class="form-label">작성자</label>
					<div class="columns">
						<div class="column col-auto">
							<div class="form-text">{{ user.user_name }}</div>
						</div>
					</div>
				</div>

				<div class="form-group">
					<label class="form-label"
						>상담 유형
						<span class="form-help form-help--required">*</span></label
					>

					<select v-model="arType" class="form-select">
						<option value="">상담 유형</option>
						<option value="칭찬">칭찬</option>
						<option value="제안">제안</option>
						<option value="불편">불편</option>
						<option value="기타">기타</option>
					</select>
				</div>

				<div class="form-group">
					<label class="form-label"
						>제목 <span class="form-help form-help--required">*</span></label
					>

					<input
						v-model="arTitle"
						class="form-input"
						type="text"
						maxlength="100"
					/>
				</div>

				<div class="form-group">
					<label class="form-label">휴대전화 번호</label>
					<div class="form-text">{{ user.user_hp }}</div>
					<p class="form-help">※ 답변 완료시 휴대폰 문자로 알려드립니다.</p>
				</div>

				<div class="form-group">
					<label class="form-label">희망 지점</label>
					<div class="columns">
						<div class="column col-6">
							<select
								v-model="arShop1"
								@change="changeBranchArea($event)"
								class="form-select"
							>
								<option value="">이용 지역</option>
								<option
									v-for="item in branchAreaList"
									:value="item.category_id"
									:key="item.uid"
								>
									{{ item.category_name }}
								</option>
							</select>
						</div>
						<div class="column col-6">
							<select v-model="arShop2" class="form-select">
								<option value="">이용 지점</option>
								<option
									v-for="item in branchList"
									:value="item.mini_company"
									:key="item.uid"
								>
									{{ item.mini_company }}
								</option>
							</select>
						</div>
						<div class="column col-12 mb-0">
							<label class="form-checkbox">
								<input v-model="hopeShop" type="hidden" />
								<!--<i class="form-icon"></i> 지점 선택 안함-->
							</label>
						</div>
					</div>
				</div>

				<div class="form-group">
					<label class="form-label"
						>내용 <span class="form-help form-help--required">*</span></label
					>
					<textarea
						v-model="arContent"
						class="form-input"
						placeholder="500자 내외"
						rows="14"
						maxlength="500"
					></textarea>
				</div>

				<div class="form-group form-button">
					<div>
						<BaseBtn type="submit" color="primary" x-large block>확인</BaseBtn>
					</div>
					<div class="mt-4">
						<BaseBtn
							@click="goToList"
							type="button"
							color="secondary"
							medium
							block
							>취소</BaseBtn
						>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import BaseBtn from '@/components/common/Btn';

import { convertHtmlToText } from '@/utils/util';

export default {
	components: {
		BaseBtn,
	},
	data() {
		return {
			arTitle: '',
			arContent: '',
			arType: '',
			arShop1: '',
			arShop2: '',
			arShop3: '',
			hopeShop: false,
		};
	},
	computed: {
		arId() {
			return this.$route.params.id;
		},
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		user() {
			return this.$store.getters['userStore/user'];
		},
		branchAreaList() {
			return this.$store.getters['appStore/branchAreaList'];
		},
		branchList() {
			return this.$store.getters['appStore/branchList'];
		},
		item() {
			return this.$store.getters['inquiryStore/userInquiryDetail'];
		},
	},
	watch: {
		arShop2(val) {
			if (this.hopeShop === true && val !== '') {
				this.hopeShop = false;
			}
		},
		hopeShop(val) {
			if (val === true) {
				this.arShop1 = '';
				this.arShop2 = '';
				this.arShop3 = '';

				// 지역이 초기화 되면서, 지역에 연관된 지점 리스트도 함께 초기화
				this.$store.commit('appStore/initBranchList');
			}
		},
	},
	created() {
		this.fetchBranchAreaList();
		if (this.arId) this.fetchUserInquiryDetail();
	},
	methods: {
		async fetchBranchAreaList() {
			return await this.$store.dispatch('appStore/getBranchAreaList');
		},
		async fetchBranchListFromAreaName() {
			const payload = {
				branchAreaName: this.arShop3,
			};

			return await this.$store.dispatch(
				'appStore/getBranchListFromAreaName',
				payload,
			);
		},
		submitInquiryForm() {
			this.arId ? this.editInquiryForm() : this.saveInquiryForm();
		},
		async editInquiryForm() {
			const payload = {
				userId: this.userId,
				arId: this.arId,
				arTitle: this.arTitle,
				arContent: this.arContent,
				arType: this.arType,
				arShop1: this.arShop1,
				arShop2: this.arShop2,
				arShop3: this.arShop3,
				hopeShop: this.hopeShop,
			};

			return await this.$store
				.dispatch('inquiryStore/updateUserInquiry', payload)
				.then(({ data }) => {
					const options = {
						message: data.message,
					};
					this.showAlert(options).then(({ ok }) => {
						if (ok === true && data.code === '00000') {
							this.$router.push({ name: 'inquiry' });
						}
					});
				});
		},
		async saveInquiryForm() {
			const payload = {
				userId: this.userId,
				arName: this.user.user_name,
				arHphone: this.user.user_hp,
				arEmail: this.user.user_email,
				arTitle: this.arTitle,
				arContent: this.arContent,
				arType: this.arType,
				arShop1: this.arShop1,
				arShop2: this.arShop2,
				arShop3: this.arShop3,
				hopeShop: this.hopeShop,
			};

			return await this.$store
				.dispatch('inquiryStore/insertUserInquiry', payload)
				.then(({ data }) => {
					const options = {
						message: data.message,
					};
					this.showAlert(options).then(({ ok }) => {
						if (ok === true && data.code === '00000') {
							this.initInquiryForm();
							this.$router.push({ name: 'inquiry' });
						}
					});
				});
		},
		async fetchUserInquiryDetail() {
			const payload = {
				arId: this.arId,
				userId: this.userId,
			};

			return await this.$store
				.dispatch('inquiryStore/getUserInquiryDetail', payload)
				.then(({ data }) => {
					if (data.code === '00000') {
						this.arTitle = this.item.ar_title;
						this.arContent = convertHtmlToText(this.item.ar_content);
						this.arType = this.item.ar_type;
						this.arShop1 = this.item.ar_shop1;
						this.arShop2 = this.item.ar_shop2;
						this.arShop3 = this.item.ar_shop3;
						this.hopeShop = this.item.hope_shop === 'Y';

						this.fetchBranchListFromAreaName();
					}
				});
		},
		changeBranchArea({ currentTarget }) {
			this.arShop3 =
				currentTarget.value === ''
					? ''
					: currentTarget.options[currentTarget.selectedIndex].text;
			this.fetchBranchListFromAreaName();
		},
		initInquiryForm() {
			this.arTitle = '';
			this.arContent = '';
			this.arType = '';
			this.arShop1 = '';
			this.arShop2 = '';
			this.arShop3 = '';
			this.hopeShop = false;
		},
		goToList() {
			this.$router.push({ name: 'inquiry' });
		},
	},
};
</script>
